import styled from 'styled-components';

import { DASHBOARD_COLUMNS, DASHBOARD_GRID_MARGIN } from './widgetSizePresets';

const [MARGIN_X, MARGIN_Y] = DASHBOARD_GRID_MARGIN;

export const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${DASHBOARD_COLUMNS}, 1fr);
  gap: ${MARGIN_Y}px ${MARGIN_X}px;
`;

export const SkeletonTile = styled.div<{ $span: number; $height: number }>`
  grid-column: span ${({ $span }) => $span};
  height: ${({ $height }) => $height}px;
  padding: 16px 18px;
  border-radius: 10px;
  background: ${({ theme }) => theme.secondaryBackgroundColor};
  border: 1px solid ${({ theme }) => theme.borderColor};
`;
